class BeddingsSet extends HTMLElement {
  constructor() {
    super();

    this.productsToAdd = [];
    this.duvetAccordion = null;
    this.setData = document.getElementById("product-set-data");
    this.groups = this.querySelectorAll("[data-set-group]");
    this.addToCartBtn = this.querySelector("[data-atc]");
    this.infoButton = this.querySelector("[data-info]");
    this.productsToAdd = [];
    this.linksBelowButton = document.querySelector(
      ".product-below-button-links"
    );
    this.infoDisclaimer = this.querySelector("[data-disclaimer-info]");
    this.totalProducts = 0;
    this.totalCount = 0;
    this.totalPrice = 0;
    this.GroupMode = Object.freeze({
      Idle: "Idle",
      AddingAnother: "AddingAnother",
      Collapsed: "Collapsed",
    });
  }

  connectedCallback() {
    // if (this.addToCartBtn.dataset.disabled) return;

    this.groups.forEach((group) => {
      this.initGroup(group);
    });

    this.addToCartBtn.addEventListener("click", (e) => {
      e.preventDefault();

      if (this.productsToAdd.length === 0 || this.addToCartBtn.dataset.disabled) return;

      this.addToCartBtn.disabled = true;
      this.addToCartBtn.classList.add("adding-to-cart");
      this.stickyATC.disabled = true;
      this.stickyATC.classList.add("adding-to-cart");

      this.addProductsToCart()
        .then(() => {
          this.resetAll();
          this.addToCartBtn.disabled = false;
          this.addToCartBtn.classList.remove("adding-to-cart");
          this.addToCartBtn.classList.add("added-to-cart");
          this.stickyATC.disabled = false;
          this.stickyATC.classList.remove("adding-to-cart");
          this.stickyATC.classList.add("added-to-cart");
          setTimeout(() => {
            this.addToCartBtn.classList.remove("added-to-cart");
            this.stickyATC.classList.remove("added-to-cart");
          }, 1200);
        })
        .then(() => {
          document.querySelector("sc-cart-drawer").setAttribute("adding", "");
        })
        .catch((err) => {
          this.addToCartBtn.disabled = false;
          this.stickyATC.disabled = false;
          this.addToCartBtn.classList.remove("adding-to-cart");
          this.stickyATC.classList.remove("adding-to-cart");
        });
    });

    //refactor
    this.stickyBar = document.querySelector(".beddings-set-sticky-bar");
    this.stickyInventory = this.stickyBar.querySelector(".bssb__inventory");
    this.stickyPrice = this.stickyBar.querySelector(".bssb__price");
    this.stickyATC = this.stickyBar.querySelector("[data-atc]");
    this.stickyATCMobile = this.stickyBar.querySelector("[data-atc-mobile]");
    this.stickyDuvet = this.stickyBar.querySelector(".bssb__duvet");
    this.stickySheet = this.stickyBar.querySelector(".bssb__sheet");
    this.stickyPillow = this.stickyBar.querySelector(".bssb__pillow");
    this.stickySheetSwatches = document.querySelector("[data-sheet-swatches]");

    this.stickyATC.addEventListener("click", () => {
      const mainBtn = this.addToCartBtn;
      if (mainBtn) mainBtn.click();
    });
    this.stickyATCMobile.addEventListener("click", () => {
      const mainBtn = this.addToCartBtn;
      if (mainBtn) mainBtn.click();
    });

    this.updateStickyBar();
    this.updateButtonsAndTopPrice();
    window.addEventListener("scroll", () => this.updateStickyBarVisibility());

    document.addEventListener("change", (e) => {
      const radio = e.target.closest("[data-sidepanel-radio]");
      if (!radio) return;

      this.handleRadioSelected(radio);
    });
  }

  getGroupElements(groupEl) {
    return {
      // general elements / inputs
      select: groupEl.querySelector("[data-group-select]"),
      swatches: groupEl.querySelector("[data-color-swatches]"),
      // buttons
      cancelBtn: groupEl.querySelector("[data-selected-cancel]"),
      addAnotherBtn: groupEl.querySelector("[data-add-another]"),
      // price/count elements
      selectedPrice: groupEl.querySelector("[data-selected-price]"),
      productCountWrapper: groupEl.querySelector("[data-group-product-count]"),
      productCount: groupEl.querySelector(
        "[data-group-product-count] [data-count]"
      ),
      totalPrice: groupEl.querySelector("[data-group-total]"),
      swatchesList: groupEl.querySelectorAll("[data-group-swatch]"),
      // items
      itemList: groupEl.querySelector("[data-added-item-list]"),
      // wrapper elements
      selectWrapper: groupEl.querySelector("[data-select-wrapper]"),
      swatchWrapper: groupEl.querySelector("[data-select-swatches-wrapper]"),
      // UI/UX elements
      check: groupEl.querySelector("[data-checkmark]"),
      emptyText: groupEl.querySelector("[data-empty-text]"),
      notEmptyText: groupEl.querySelector("[data-not-empty-text]"),
    };
  }

  initGroup(groupEl) {
    if (!groupEl) return;

    // group = all child elements
    // groupEl = parent element, group in DOM
    const group = this.getGroupElements(groupEl);
    groupEl.dataset.mode = this.GroupMode.Idle;

    group.cancelBtn.addEventListener("click", () => {
      this.exitSelection(groupEl, group);
    });
    group.addAnotherBtn.addEventListener("click", () => {
      this.addAnother(groupEl, group);
    });

    if (group.select) {
      group.select.addEventListener("change", (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        this.groupItemSelected(groupEl, group, selectedOption);
      });
    }
  }

  updateGroupUI(groupEl, group, mode) {
    groupEl.dataset.mode = mode;

    const hide = (el, shouldHide) =>
      el && el.classList.toggle("hidden", shouldHide);

    if (groupEl.dataset.productCount > 0) {
      hide(group.productCount, false);
      hide(group.totalPrice, false);
      hide(group.notEmptyText, false);
      hide(group.emptyText, true);
      hide(group.addAnotherBtn, false);
      hide(group.productCountWrapper, false);
    } else {
      hide(group.productCount, false);
      hide(group.totalPrice, true);
      hide(group.notEmptyText, true);
      hide(group.emptyText, false);
      hide(group.addAnotherBtn, true);
      hide(group.productCountWrapper, true);
    }

    switch (mode) {
      case this.GroupMode.Idle:
        hide(group.selectWrapper, groupEl.dataset.productCount > 0);
        hide(group.swatchWrapper, groupEl.dataset.productCount > 0);
        hide(group.check, true);
        hide(group.cancelBtn, true);
        group.selectedPrice.textContent = "";
        break;

      case this.GroupMode.AddingAnother:
        hide(group.selectWrapper, false);
        hide(group.swatchWrapper, false);
        hide(group.check, true);
        hide(group.cancelBtn, false);
        hide(group.addAnotherBtn, true);
        group.selectedPrice.textContent = "";
        break;

      case this.GroupMode.Collapsed:
        hide(group.selectWrapper, true);
        hide(group.swatchWrapper, true);
        hide(group.check, true);
        hide(group.cancelBtn, true);
        group.selectedPrice.textContent = "";
        break;
    }

    if (group.swatchesList) {
      const selectedSwatches = Array.from(
        group.itemList.querySelectorAll("[data-swatch-index]")
      ).map((el) => el.getAttribute("data-swatch-index"));

      group.swatchesList.forEach((swatch) => {
        const swatchIndex = swatch.getAttribute("data-swatch-index");

        const shouldHide = !selectedSwatches.includes(swatchIndex);
        hide(swatch, shouldHide);
      });
    }
    this.updateAddToCartState();

    groupEl.resize();
  }

  updateAddToCartState() {
    if (this.addToCartBtn.dataset.disabled) return;

    const hasAnyItems = Array.from(this.groups).some(
      (group) => Number(group.dataset.productCount) > 0
    );
    this.addToCartBtn.disabled = !hasAnyItems;
  }

  groupItemSelected(groupEl, group, option) {
    // No confirmation step: picking a size adds that item right away.
    if (!option || !option.dataset.id) {
      this.updateGroupUI(groupEl, group, this.GroupMode.Idle);
      return;
    }

    this.addItem(groupEl, group);
  }

  exitSelection(groupEl, group) {
    group.select.selectedIndex = 0;

    this.updateGroupUI(groupEl, group, this.GroupMode.Idle);
  }

  updateTotals(groupEl, group) {
    const items = groupEl.querySelectorAll("[data-added-item]");
    let priceTotal = 0;
    let productCount = 0;

    items.forEach((item) => {
      const qty = Number(item.querySelector("[data-item-qty]").value);
      const itemPrice = Number(item.getAttribute("data-price"));
      priceTotal += qty * itemPrice;
      productCount += qty;
    });

    groupEl.dataset.productCount = productCount;
    groupEl.dataset.total = priceTotal;
    group.productCount.innerHTML = productCount;
    group.totalPrice.innerHTML = Shopify.formatMoney(
      priceTotal,
      window.themeData.moneyFormat
    );

    groupEl.resize();
  }

  initItem(item, groupEl, group) {
    const qtyInput = item.querySelector("[data-item-qty]");
    const qtyMinus = item.querySelector("[data-item-qty-minus]");
    const qtyPlus = item.querySelector("[data-item-qty-plus]");
    const deleteBtn = item.querySelector("[data-item-delete]");
    const priceEl = item.querySelector("[data-item-price]");
    let productCount = Number(groupEl.dataset.productCount);

    qtyMinus.addEventListener("click", () => {
      let val = Number(qtyInput.value);
      if (val > 1) {
        qtyInput.value = val - 1;
        this.updateTotals(groupEl, group);

        this.updateProductsArray();
        this.updateStickyBar();
        this.updateButtonsAndTopPrice();
      }
    });

    qtyPlus.addEventListener("click", () => {
      qtyInput.value = Number(qtyInput.value) + 1;
      this.updateTotals(groupEl, group);

      this.updateProductsArray();
      this.updateStickyBar();
      this.updateButtonsAndTopPrice();
    });

    qtyInput.addEventListener("input", () => {
      if (qtyInput.value < 1) qtyInput.value = 1;
      this.updateTotals(groupEl, group);

      this.updateProductsArray();
      this.updateStickyBar();
      this.updateButtonsAndTopPrice();
    });

    deleteBtn.addEventListener("click", () => {
      item.remove(groupEl);

      productCount--;
      if (productCount < 0) productCount = 0;
      groupEl.dataset.productCount = productCount;
      group.productCount.innerHTML = productCount;

      this.updateTotals(groupEl, group);

      this.updateProductsArray();
      this.updateStickyBar();
      this.updateButtonsAndTopPrice();
      this.updateGroupUI(groupEl, group, this.GroupMode.Idle);
    });
  }

  addItem(groupEl, group) {
    let productCount = Number(groupEl.dataset.productCount);
    let priceTotal = Number(groupEl.dataset.total);

    const selectedOption = group.select.options[group.select.selectedIndex];
    const newItem = document.createElement("div");
    const swatchInput = groupEl.querySelector(
      'input[name="sheet-color"]:checked'
    );

    newItem.classList.add("pbs__item");
    newItem.setAttribute("data-added-item", "");
    newItem.setAttribute("data-variant-id", selectedOption.dataset.id);
    newItem.setAttribute("data-price", selectedOption.dataset.price);
    const itemHtml = `
      <div class="pbs__item-title">
        ${
          swatchInput != null
            ? swatchInput.closest("label").querySelector("[data-swatch-index]")
                .outerHTML
            : ""
        }
        <span>${selectedOption.value}</span>
      </div>
      <div class="pbs__item-actions">
        <div class="pbs__item-quantity">
          <button class="pbs__item-qty-button" data-item-qty-minus>
            <span class="svg-wrapper">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 16H24" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
              </svg>
            </span>
          </button>
          <input class="pbs__item-qty" type="number" value="1" name="item-qty" data-item-qty>
          <button class="pbs__item-qty-button">
            <span class="svg-wrapper" data-item-qty-plus>
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 16H24" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                <path d="M16 24V8" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
              </svg>
            </span>
          </button>
        </div>
        <div class="pbs__item-delete" data-item-delete>${this.dataset.deleteText}</div>
        <div class="pbs__item-price" data-item-price>${
          selectedOption.dataset.priceMoney
        }</div>
      </div>
    `;
    newItem.innerHTML = itemHtml;

    productCount++;

    group.select.selectedIndex = 0;
    group.selectedPrice.innerHTML = "";

    group.itemList.appendChild(newItem);
    group.productCount.innerHTML = productCount;
    groupEl.dataset.productCount = productCount;

    priceTotal = priceTotal + Number(selectedOption.getAttribute("data-price"));
    groupEl.dataset.total = priceTotal;
    group.totalPrice.innerHTML = Shopify.formatMoney(
      priceTotal,
      window.themeData.moneyFormat
    );

    this.initItem(newItem, groupEl, group);

    this.updateProductsArray();
    this.updateStickyBar();
    this.updateButtonsAndTopPrice();
    this.updateGroupUI(groupEl, group, this.GroupMode.Collapsed);

    const radio = document.querySelector("[data-sidepanel-radio]:checked");
    if (radio) radio.checked = false;
  }

  addAnother(groupEl, group) {
    this.updateGroupUI(groupEl, group, this.GroupMode.AddingAnother);
  }

  updateProductsArray() {
    this.productsToAdd = [];

    this.groups.forEach((groupEl) => {
      const items = groupEl.querySelectorAll("[data-added-item]");
      items.forEach((item) => {
        const qtyInput = item.querySelector("[data-item-qty]");
        const quantity = Number(qtyInput?.value || 1);
        const variantId = Number(item.getAttribute("data-variant-id"));
        const swatchEl = item.querySelector("[data-swatch-index]");
        const swatchName = swatchEl?.getAttribute("data-swatch-name");

        const product = {
          id: variantId,
          quantity,
          ...(swatchName ? { properties: { SheetColour: swatchName } } : {}),
        };

        this.productsToAdd.push(product);
      });
    });
  }

  async addProductsToCart() {
    if (!this.productsToAdd.length) return;

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: this.productsToAdd }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.description || "Add to cart failed");
    }

    const data = await response.json();

    return data;
  }

  resetAll() {
    this.productsToAdd = [];

    this.totalProducts = 0;
    this.totalPrice = 0;

    this.groups.forEach((groupEl) => {
      const group = this.getGroupElements(groupEl);

      group.itemList.innerHTML = "";

      groupEl.dataset.productCount = "0";
      groupEl.dataset.total = "0";

      if (group.productCount) group.productCount.textContent = "0";
      if (group.totalPrice) group.totalPrice.textContent = "";

      if (group.select) group.select.selectedIndex = 0;
      if (group.selectedPrice) group.selectedPrice.textContent = "";

      this.updateStickyBar();
      this.updateButtonsAndTopPrice();
      this.updateGroupUI(groupEl, group, this.GroupMode.Idle);
      groupEl.close();
    });

    this.addToCartBtn.disabled = true;
  }

  updateButtonsAndTopPrice() {
    if (!this.linksBelowButton)
      this.linksBelowButton = document.querySelector(
        ".product-below-button-links"
      );
    const productPrice = document.querySelector(".product-price-info");
    const productPriceWrapper = document.querySelector(
      ".product-price-wrapper"
    );
    const productPriceInstallements = document.querySelector(
      ".heidipay_inline_wrapper "
    );
    const productPriceInstallementValue = document.querySelector(
      ".heidipay_inline_monthly_amount "
    );
    const productPriceList = document.querySelector(".price-product-list ");

    if (this.totalCount > 0) {
      this.addToCartBtn.classList.remove("hidden");
      this.linksBelowButton.classList.remove("hidden");
      this.infoButton.classList.add("hidden");
      this.infoDisclaimer.classList.add("hidden");
      console.log("total:", this.totalPrice);
      productPriceWrapper.innerHTML = Shopify.formatMoney(
        this.totalPrice,
        window.themeData.moneyFormat
      );
      productPriceInstallementValue.innerHTML = Shopify.formatMoney(
        this.totalPrice / 4,
        window.themeData.moneyFormat
      );
      productPriceInstallements.style.opacity = 1;
      productPriceList.innerHTML = this.stickyInventory.innerHTML;
    } else {
      this.addToCartBtn.classList.add("hidden");
      this.linksBelowButton.classList.add("hidden");
      this.infoButton.classList.remove("hidden");
      this.infoDisclaimer.classList.remove("hidden");
      // productPriceWrapper.style.opacity = 0;
      // productPriceInstallements.style.opacity = 0;
      productPriceList.innerHTML = ""; 
      // setTimeout(() => {
      //   productPriceWrapper.innerHTML = "SELECT ITEMS";
      //   productPriceWrapper.style.opacity = 1;
      // }, 1000);
    }
  }

  updateStickyBar() {
    let totalCount = 0;
    let totalPrice = 0;

    let duvetCount = 0,
      sheetCount = 0,
      pillowCount = 0;

    this.groups.forEach((groupEl) => {
      const groupType = groupEl.dataset.setGroup;
      const count = Number(groupEl.dataset.productCount || 0);
      const price = Number(groupEl.dataset.total || 0);

      totalCount += count;
      // refactor: updating totalCount should be moved elsewhere
      this.totalCount = totalCount;
      totalPrice += price;

      switch (groupType) {
        case "duvet":
          duvetCount = count;
          break;
        case "sheet":
          sheetCount = count;
          break;
        case "pillow":
          pillowCount = count;
          break;
      }

      if (this.stickySheetSwatches && groupType == "sheet") {
        const selectedSwatches = Array.from(
          groupEl
            .querySelector("[data-added-item-list]")
            .querySelectorAll("[data-swatch-index]") || []
        ).map((el) => el.getAttribute("data-swatch-index"));

        this.stickySheetSwatches
          .querySelectorAll("[data-group-swatch]")
          .forEach((swatch) => {
            const swatchIndex = swatch.getAttribute("data-swatch-index");
            const shouldHide = !selectedSwatches.includes(swatchIndex);
            swatch.classList.toggle("hidden", shouldHide);
          });
      }
    });

    this.stickyDuvet.querySelector("[data-count]").textContent = duvetCount;
    this.stickySheet.querySelector("[data-count]").textContent = sheetCount;
    this.stickyPillow.querySelector("[data-count]").textContent = pillowCount;

    this.stickyDuvet.style.display = duvetCount ? "flex" : "none";
    this.stickySheet.style.display = sheetCount ? "flex" : "none";
    this.stickyPillow.style.display = pillowCount ? "flex" : "none";

    this.totalPrice = totalPrice;
    this.stickyPrice.textContent = Shopify.formatMoney(
      totalPrice,
      window.themeData.moneyFormat
    );

    const separator1 = this.stickyBar.querySelector("[data-separator-1]");
    const separator2 = this.stickyBar.querySelector("[data-separator-2]");

    if (separator1)
      separator1.style.display =
        (duvetCount && sheetCount) || (duvetCount && pillowCount)
          ? "block"
          : "none";

    if (separator2)
      separator2.style.display = sheetCount && pillowCount ? "block" : "none";

    this.updateStickyBarVisibility();
  }

  updateStickyBarVisibility() {
    if (this.totalCount > 0 && this.hasScrolledPastATC()) {
      this.stickyBar.classList.add("active");
    } else {
      this.stickyBar.classList.remove("active");
    }
  }

  hasScrolledPastATC() {
    const rect = this.addToCartBtn.getBoundingClientRect();
    return rect.top < 0;
  }

  handleRadioSelected(radio) {
    const groupType = radio.dataset.group;
    const variantId = radio.dataset.variantId;
    const sidepanelEl = radio.closest("sidepanel-el");

    if (!groupType || !variantId) return;

    const groupEl = Array.from(this.groups).find(
      (g) => g.dataset.setGroup === groupType
    );
    if (!groupEl) return;

    const group = this.getGroupElements(groupEl);
    if (!group.select) return;

    const targetOption = Array.from(group.select.options).find(
      (opt) => opt.dataset.id === variantId
    );

    if (!targetOption) return;

    group.select.value = targetOption.value;

    this.groupItemSelected(groupEl, group, targetOption);

    if (sidepanelEl) sidepanelEl.close();
  }
}

customElements.define("beddings-set", BeddingsSet);
